export default "__VITE_ASSET__6be08de3__"